import { Box, Text, Container } from "@chakra-ui/react";
import ButtonSpoleto from "../Button";
import TitleSpoleto from "../Title";
import SubTitle from "../SubTitle";
import RulesText from "./RulesText";

const Rules = () => {
  const downloadRules = () => {
    const url = "/assets/files/Regulamento.pdf";
    window.open(url);
  };
  return (
    <Box id="regulamento" py={12} bg="#5B3923" pb={16}>
      <Container maxW="container.xl">
        <TitleSpoleto>Regulamento</TitleSpoleto>
        <SubTitle>Leia nosso regulamento atentamente!</SubTitle>
        <Box
          w="100%"
          maxW="85%"
          mx="auto"
          overflow="hidden"
          bg="#fff"
          px={2}
          py={4}
          mt={8}
          mb={[0, null, 4]}
        >
          <Box
            w="100%"
            maxH={["300px", null, "400px"]}
            bg="#fff"
            overflowY="auto"
            borderRadius={0}
            className="box-regulamento"
            pl={8}
            pr={8}
          >
            <Text
              fontSize={["sm", null, "md"]}
              color="#83411E"
              lineHeight="21.8px"
              textAlign="left"
            >
              <RulesText />
            </Text>
          </Box>
        </Box>
        <ButtonSpoleto
          fontFamily="FiraSansLight"
          fontSize={["20px", null, "24px"]}
          maxW={["80%", null, "50%"]}
          mx="auto"
          mt={8}
          onClick={downloadRules}
        >
          Baixar o regulamento
        </ButtonSpoleto>
      </Container>
    </Box>
  );
};

export default Rules;
